const STORAGE_KEY = 'geomarkup_pending_invitation';
const TTL_MS = 30 * 60 * 1000; // 30 minutes

interface PendingInvitation {
  token: string;
  action: string;
  savedAt: number;
}

export function savePendingInvitation(token: string, action: string): void {
  const entry: PendingInvitation = { token, action, savedAt: Date.now() };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entry));
}

export function getPendingInvitation(): PendingInvitation | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const entry: PendingInvitation = JSON.parse(raw);
    if (!entry.token || !entry.action || !entry.savedAt) return null;

    if (Date.now() - entry.savedAt > TTL_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }

    return entry;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function clearPendingInvitation(): void {
  localStorage.removeItem(STORAGE_KEY);
}
